<template>
  <v-list nav>
    <!-- Single Menus -->
    <div class="mb-3" v-for="(menu, i) in singleMenus" :key="i">
      <v-list-item
        active-class="ims-nav-active"
        :to="menu.link"
        v-if="!menu.subMenus"
      >
        <v-list-item-icon>
          <v-icon v-text="menu.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-title v-text="menu.name"></v-list-item-title>
      </v-list-item>
      <v-list-group
        :prepend-icon="menu.icon"
        no-action
        active-class=""
        :class="{ 'ims-nav-group-active': isMenuRouteActive(menu) }"
        v-if="menu.subMenus"
      >
        <template v-slot:activator>
          <v-list-item-title>{{menu.name}}</v-list-item-title>
        </template>
        <v-list-item
          v-for="(smenu, i) in menu.subMenus"
          :key="i"
          exact
          :to="smenu.link"
          active-class="ims-nav-active"
        >
          <v-list-item-title v-text="smenu.name"></v-list-item-title>
          <v-list-item-icon>
            <v-icon v-text="smenu.icon"></v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </div>
    <div v-if="isNotClientRole">
      <v-divider></v-divider>
      <!-- Group Menus -->
      <v-list-group
        v-for="gmenu in groupMenus"
        :key="gmenu.name"
        :prepend-icon="gmenu.icon"
        no-action
        active-class=""
        :class="[`menu-${gmenu.name}-group`, { 'ims-nav-group-active': isMenuRouteActive(gmenu) }]"
      >
        <template v-slot:activator>
          <v-list-item-title>{{gmenu.name}}</v-list-item-title>
        </template>
        <v-list-item
          v-for="(smenu, i) in gmenu.subMenus"
          :key="i"
          exact
          :to="smenu.link"
          active-class="ims-nav-active"
        >
          <v-list-item-title v-text="smenu.name"></v-list-item-title>
          <v-list-item-icon>
            <v-icon v-text="smenu.icon"></v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </div>
  </v-list>
</template>
<script>
import config from '@/config';
export default {
  name: 'DrawerMenu',
  props: {
    singleMenus: Array,
    groupMenus: Array
  },
  computed: {
    isNotClientRole: function () {
      // show paired amount except for client side
      return Number(this.$store.state.user.role) !== config.userRoles.CLIENT;
    }
  },
  methods: {
    isMenuRouteActive(menu) {
      const currentPath = this.$route.path;
      return Array.isArray(menu.subMenus) && menu.subMenus.some(subMenu => {
        return this.isRoutePathMatch(currentPath, subMenu.link);
      });
    },
    isRoutePathMatch(currentPath, menuPath) {
      if (!menuPath) {
        return false;
      }
      return currentPath === menuPath || currentPath.startsWith(`${menuPath}/`);
    }
  }
}
</script>
<style>
  .menu-Complete-group {
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(244, 244, 244, 0.18);
  }

  .menu-Financial-group {
    padding-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// DrawerNavList.vue?9f330248